var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.96,6.19h-.64c-3.47,0-6.95,0-10.42,0-.18,0-.36,0-.53-.03-.44-.1-.67-.39-.67-.83,0-.44.24-.73.68-.83.17-.04.35-.03.53-.03,3.47,0,6.95,0,10.42,0h.63c0-.75.01-1.44,0-2.13-.02-.71.24-1.24.89-1.54.61-.28,1.18-.12,1.75.45,1.11,1.11,2.23,2.22,3.34,3.34.53.54.53.96,0,1.5-1.12,1.13-2.25,2.25-3.37,3.37-.54.54-1.13.68-1.72.4-.62-.29-.9-.81-.88-1.49.02-.71,0-1.42,0-2.17Zm1.72,1.52c.82-.8,1.66-1.62,2.41-2.34-.8-.8-1.61-1.62-2.41-2.42v4.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.04,15.54c0,.74-.02,1.42,0,2.1.02.72-.23,1.29-.9,1.58-.68.3-1.25.06-1.75-.45-1.1-1.12-2.23-2.23-3.34-3.34-.52-.52-.52-.96-.01-1.47,1.13-1.14,2.27-2.27,3.41-3.41.48-.48,1.04-.68,1.68-.41.63.27.92.78.91,1.47-.01.71,0,1.42,0,2.21.23,0,.42,0,.6,0,3.47,0,6.95,0,10.42,0,.16,0,.33,0,.49.02.47.07.77.42.76.86,0,.43-.29.75-.74.83-.16.03-.32.02-.49.02-3.46,0-6.91,0-10.37,0h-.67Zm-4.12-.95c.8.82,1.62,1.65,2.38,2.42v-4.79c-.83.83-1.65,1.64-2.38,2.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.1738f85a59817e02d957ce8402130574.svg";
export { ForwardRef as ReactComponent };